import { faQuoteLeft, faQuoteLeftAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const Section9 = () => {
  const profiles = [
    {
      img: "/assets/Landing/Profile/Manju.jpg",
      name: "Manjunath Vijay ",
      job: " CEO & Co-Founder, Skilleareum",
      desc: "Proud to redefine education as a borderless, gamified journey where skills become real value through zk-Proof of Learning and Smart Minting. ",
    },
    {
        img: "/assets/Hudson.png",
        name: "Hudson Daniel ",
        job: " CMO & Co-Founder, Skilleareum ",
        desc: "Skilleareum is an AI-driven Web3 platform where users learn in-demand skills, access AI-powered opportunities, and earn crypto rewards while fostering a lifelong learning community.",
      },
      {
        img: "/assets/Landing/Profile/Sakthi.jpg",
        name: "Sakthi Visakan Rajaguru ",
        job: "Chief Mentor, Skilleareum",
        desc: "Skilleareum leverages AI-powered personalized learning paths to help users enhance their skills, stay ahead in emerging technologies, and earn rewards through skill-based challenges and assessments. ",
      },
      {
        img: "/assets/Landing/Profile/Anup2.png",
        name: "Anup Kumar",
        job: "CTO",
        desc: "Skilleareum gamifies learning with AI-driven quizzes, real-world projects, and on-chain rewards, making skill growth engaging and rewarding.",
      },
      // {
      //   img: "/assets/New/Landing/Profile/Prabitha.jpg",
      //   name: "Prabitha  ",
      //   job: "Project Manager",
      //   desc: "Skilleareum connects learners, mentors, and experts, fostering collaboration, knowledge sharing, and career growth in the decentralized ecosystem.",
      // },
      // {
      //   img: "/assets/New/Landing/Profile/Vishaly.JPG",
      //   name: "Vishaly",
      //   job: "DM Director",
      //   desc: "Skilleareum is set to revolutionize the AI learning by empowering thousands to monetize their skills through a gamified, global Learn-and-Earn ecosystem. ",
      // },
      {
        img: "/assets/Landing/Profile/Dinesh.jpg",
        name: "Dinesh",
        job: "Smart Contract Developer ",
        desc: "Skilleareum brings together students, mentors, and industry professionals, encouraging collaboration, knowledge exchange, and career advancement in a decentralized space.",
      },
      {
        img: "/assets/Landing/Profile/Mani.jpg",
        name: "Mani  ",
        job: "Lead Developer",
        desc: "Skilleareum redefines AI learning by enabling individuals to earn from their expertise through an interactive, reward-based global ecosystem.",
      },
      // {
      //   img: "/assets/New/Landing/Profile/Thomas.jpg",
      //   name: "Thomas",
      //   job: "UI / UX Lead",
      //   desc: "Skilleareum integrates AI-powered challenges, hands-on projects, and blockchain-based incentives to make learning dynamic, practical, and financially rewarding. ",
      // },
  ];
  return (
    <div className="font-gilroy py-20">
      <div className="flex flex-col items-center gap-5">
        <h1
          style={{
            backgroundClip: "text",
            color: "transparent",
            backgroundImage:
              "linear-gradient(to right, #0285FF, #FFFFFF, #FFFFFF, #1EEF32)",
            WebkitBackgroundClip: "text",
          }}
          className="text-center font-medium text-5xl"
        >
          Let's Hear from our Team
        </h1>
        {/* <p className="text-sm text-center">
          Let’s here from other founder, Co-founders
        </p> */}
      </div>

      <div className="mt-10">
        <div className=" grid md:grid-cols-3 grid-cols-1 gap-5 h-full ">
        {profiles.map((data, index) => (
          <div key={index} className="h-full bg-gradient-to-br from-white to-white/0 to-30% p-[1px] rounded-2xl ">
        
              <div  className="bg-[#0a0a0a] h-full hover:backdrop-blur-md hover:bg-[#0a0a0a]/80 cursor-pointer rounded-2xl p-5">
                <div className="flex justify-between">
                  <div className="flex items-center gap-3">
                    <img src={data.img} className="w-12 h-12 rounded-full object-cover  object-center " />
                    <div>
                      <p className=" font-medium ">{data.name}</p>
                      <p className="text-xs">{data.job}</p>
                    </div>
                  </div>
                  <div className=" scale-150 ">
                  <i class="fa-solid fa-quote-left "></i>
                  </div>
                </div>
                <div className="mt-7">
                  <p className="font-light text-sm">{data.desc}</p>
                </div>
              </div>
          
          </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Section9;
